import clsx from "clsx";
import Image from "next/image";

import { getSEOPageProps } from "../lib/seo";

import CarouselMultiple from "../components/carousel-multiple";
import Hero from "../components/hero";

import OurValues from "../components/our-values";
import Slide from "../components/slide/slide";
import SeoMeta from "../components/seo-meta";

import styles from "./about-us.module.scss";
import config from "../config";

export default function AboutUsPage({ seo }) {
  const slides = [
    {
      image: "/images/about-us-1.jpg",
      title:
        "Front row: Dave Anderson, David Bennell, Jim Anderson, so on, in the Funnel theatre.",
      byline:
        "Funnel Film Collective | January 10, 1979 | Photo by John Porter",
    },
    {
      image: "/images/about-us-2.jpg",
      title:
        "Interior Designer. Opened manufacturing business in 1975; The Drapery Workshop.",
      byline: "Liz Young | 1993",
    },
    {
      image: "/images/about-us-3.jpg",
      title: "Edie Steiner and Stephen Niblock.",
      byline: "Funnel Film Collective | 1979 | Photo by John Porter",
    },
    {
      image: "/images/about-us-4.jpg",
      title:
        "Cabinet Maker. Fascinated in the art of marquetry. Foremost restorer of fine furniture.",
      byline: "Victor Bortolussi | 1993",
    },
    {
      image: "/images/about-us-5.jpg",
      title: "Printing and drying 2nd edition of Funnel t-shirts.",
      byline: "Funnel Film Collective | April 26, 1981 | Photo by John Porter",
    },
    {
      image: "/images/about-us-6.jpg",
      title: "Artist. Motorcycle photographer.",
      byline: "Douglas MacRae | January 16, 2022",
    },
    {
      image: "/images/about-us-7.jpg",
      title: "Artist of Three Dimensional Farmstead.",
      byline: "Julia McNeely | 1993",
    },
    {
      image: "/images/about-us-8.jpg",
      title: "Scott and Beth B in the Funnel theatre.",
      byline:
        "Funnel Film Collective | October 17, 1979 | Photo by John Porter",
    },
  ];

  return (
    <div className={clsx("container", styles.AboutUs)}>
      <SeoMeta {...seo} />

      <Hero
        title="About Us"
        description="East Room was founded in 2014 with the vision to develop an environment that enhances the personal and professional well-being of our members and extended community through intentional design, authentic programming, diverse community, and exceptional hospitality."
      />

      <figure className="relative my-12 px-4 md:px-0">
        <Image
          src="/images/about-us.jpg"
          alt="Founding address, 50 Carroll St. (1928)"
          width="1240"
          height="830"
          layout="responsive"
          objectFit="cover"
        />
        <figcaption>Founding address, 50 Carroll St. (1928)</figcaption>
      </figure>

      <div className={styles.Content}>
        <p className={styles.Intro}>
          The Martin Family have been in the design and real estate business for
          decades.
        </p>

        <p>
          Scott Martin (b. 1930-2008) began his professional life as an actuary,
          later shifting into real estate. Initially buying and converting
          residential properties around Toronto, he pooled his resources to
          purchase two commercial buildings, 50 Carroll St. and 507 King St.
          East, both of which are now East Room locations.
        </p>
        <p>
          He was a loyal custodian to both properties, reshaping them from
          derelict industrial buildings into creative live - work communities.
          Film screenings, art installations, and after-hour concerts were
          commonplace and supported enthusiastically by Scott as he sought to
          foster a community that valued expression and experimentation.
        </p>
      </div>

      <div className={styles.SliderWrapper}>
        <CarouselMultiple>
          {slides.map((slide) => (
            <Slide key={slide.title} {...slide} />
          ))}
        </CarouselMultiple>
      </div>

      <div className={styles.Content}>
        <p>
          Scott&apos;s son, Kent Martin (b. 1960-2014), was the founder of 507
          Antiques, one of the largest antiques importing businesses in North
          America, with stores in Toronto, New York, and Palm Beach. His
          business operated as a hub for the industry, catering to retailers,
          designers, and the general public alike-filling the homes of
          collectors around the world with one-of-a-kind pieces.{" "}
        </p>
      </div>

      <div className={styles.Content}>
        <figure className={styles.FamilyPhoto}>
          <Image
            src="/images/martin-family.jpg"
            alt="The Martin Family (1993)"
            width="730"
            height="730"
            layout="responsive"
            objectFit="cover"
          />
          <figcaption className="font-light">
            The Martin Family (1993)
          </figcaption>
        </figure>
      </div>

      <div className={styles.Content}>
        <p>
          Derreck Martin, our co-founder and president, was born into this world
          of real estate and design with an instilled appreciation for the
          community driven approach to business and entrepreneurial spirit his
          grandfather and father embodied. East Room was created as a union of
          the two men’s lifelong pursuits, and continues to uphold their values
          to this day.
        </p>

        <p>
          Through our deep focus on well intentioned design, diversity in our
          community, thoughtful programming and exceptional hospitality; we
          ensure your experience in our work environments are unique and
          unrivalled. We are dedicated to fulfilling this promise for every one
          of our members, whether they are an independent freelancer or an
          established company.
        </p>
      </div>

      <OurValues />
    </div>
  );
}

export async function getStaticProps() {
  return {
    props: {
      seo: await getSEOPageProps({ resolvedUrl: "/about-us" }),
    },
    revalidate: config.ISR_TIMING,
  };
}
